<template>
  <div class="swith-list">
    <p>开启提醒</p>
    <cube-switch v-model="selectValue" @input="changeValue"></cube-switch>
  </div>
</template>
<script>
export default {
  name: 'SwitchList',
  props: {
    valueS: {
      type: Boolean,
      default: true
    },
    name: {
      type: String,
      default: '开启提醒'
    }
  },
  data () {
    return {
      selectValue: this.valueS
    }
  },
  methods: {
    changeValue () {
      this.$emit('change', this.selectValue)
    }
  },
  watch: {
    valueS (newValue) {
      this.selectValue = newValue
    }
  }
}
</script>
<style lang="stylus" scoped>
@import "~styles/mixins.styl"
  .swith-list
    height 44px
    line-height 44px
    color #333333
    font-size 14px
    border-bottom 1px solid #ededed
    rowSpaceBetween()
</style>


// WEBPACK FOOTER //
// src/components/SwitchList/SwitchList.vue